import appConstants from "../../../../../appConstants";
import { MultiSelectFilter } from "../../../../dataGrid/columnFilters";
import Tooltip from "../../../../common/StyledToolTip";

export default class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }
      static getConfiguration({ terminalAccessLabel }) {
        return GridConfig.getDefaultConfiguration({ terminalAccessLabel });
    }

    static CommandCellRenderer(props){
      // const { isLocked } = props.data;
      const iconStyle={cursor:"pointer"};
      return (<div style={{
        display:"flex",
        justifyContent:"space-between",
        padding:"8px 16px 0 0"
      }}
        onClick={(event) => props.api.runCommand && props.api.runCommand(event.target.getAttribute("data-command"), props)}
      >
        <Tooltip title="Edit User"><i style={iconStyle} className="icon-icon_edit" data-command={"editUser"}/></Tooltip>
        {/* <Tooltip title={`${isLocked ? "Unlock User" :"Lock User"}`}>
          {isLocked ? <i style={iconStyle} className="icon-locked" data-command={"unlockUser"}/> :
                      <i style={iconStyle} className="icon-unclock" data-command={"lockUser"}/>
          }
        </Tooltip> */}
        <Tooltip title="Delete User"><i style={iconStyle} className="icon-icon_delete" data-command={"deleteUser"}/></Tooltip>
        {/* <Tooltip title="Reset User password"><i style={iconStyle} className="icon-ccw" data-command={"resetUserPassword"}/></Tooltip> */}
      </div>)
    }

  static getDefaultConfiguration({ terminalAccessLabel }) {
    return {
      title: appConstants.gridNames.TerminalAcces,
      keyColumn: "userId",
      rowSelection: "single",
      defaultColDef:{
        sortable: true,
        filter: true,
        resizable: true,
        filterFramework:MultiSelectFilter
      },
      columns: [
        {
          headerName: "User ID",
          field: "userId",
          hide: true,
          headerTooltip: "user ID"
        },
        {
          headerName: "Username",
          headerTooltip: "Username",
          field: "userName",
          minWidth: appConstants.columnWidth.TERMINAL_USER,
        },
        {
          headerName: "First Name",
          headerTooltip: "First Name",
          field: "firstName",
          minWidth: appConstants.columnWidth.TERMINAL_FIRSTNAME,

        },
        {
          headerName: "Last Name",
          headerTooltip: "Last Name",
          field: "lastName",
          minWidth: appConstants.columnWidth.TERMINAL_LASTNAME,
        },
        {
          headerName: "Email",
          headerTooltip: "Email",
          field: "email",
          minWidth: appConstants.columnWidth.TERMINAL_EMAIL,
        },
        {
          headerName: "Job Title",
          headerTooltip: "Job Title",
          field: "jobTitle",
          minWidth: appConstants.columnWidth.TERMINAL_JOBTITLE,
        },
        {
          headerName: `Default ${terminalAccessLabel.shortName}`,
          headerTooltip: `Default ${terminalAccessLabel.fullName}`,
          field: "defaultTerminal",
          minWidth: appConstants.columnWidth.TERMINAL_DEFAULTTERMINAL,
        },
        {
          headerName:
            `Accessible ${terminalAccessLabel.shortName}s`,
          headerTooltip:
            `Accessible ${terminalAccessLabel.fullName}s`,
          field: "otherTerminals",
          tooltipField: "otherTerminals",
          minWidth: appConstants.columnWidth.TERMINAL_TERMINALLIST,
        },
        {
          headerName: "Commands",
          headerTooltip: "Commands",
          field: "command",
          cellRendererFramework: GridConfig.CommandCellRenderer,
          minWidth: appConstants.columnWidth.TERMINAL_COMMANDS,
          maxWidth: appConstants.columnWidth.TERMINAL_COMMANDS,
          filter: false,
          filterFramework: null
        },
      ]
    }
  }
}

